<section class="additional-options" [formGroup]="additionalOptionsForm">
  <div class="content flex-column">
    <article class="flex-row due-date">
      <vdw-datepicker-form-input
        [inputLabel]="'GENERAL.DATETIME.DUE_DATE' | bmsTranslate"
        [form]="additionalOptionsForm"
        formControlNameValue="dueDate"
        [minValue]="getEarliestPossibleDueDate()"
        [hint]="'GENERAL.HINTS.UNAUTHORIZED' | bmsTranslate"
        [showHint]="!hasScheduleDueDatePermission()"
        (dateChange)="onDateChange()"
      ></vdw-datepicker-form-input>
      <mat-form-field>
        <mat-label>{{ 'GENERAL.COMMENT' | bmsTranslate }}</mat-label>
        <input matInput formControlName="comment" />
      </mat-form-field>
    </article>

    @if (canSelectBuggy()) {
      <article class="flex-column additional-option-wrapper">
        <h3 class="font-weight-semibold">{{ 'PLANNING.BUGGY.BUGGY' | bmsTranslate: {count: 1} }}</h3>

        <div>
          <mat-form-field>
            <mat-label>{{ 'PLANNING.BUGGY.BUGGY' | bmsTranslate: {count: 1} }}</mat-label>
            <vdw-object-selection formControlName="buggy" [objectName]="'PLANNING.BUGGY.BUGGY' | bmsTranslate: {count: 1} | lowercase" (selectClicked)="selectBuggy()"></vdw-object-selection>
            <mat-error *vdwCanShowErrorForFormControl="'buggy'; error: 'required'">
              {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </article>
    }

    <article *appHasPermission="FINISHING_VIEW_PERMISSION" class="flex-column additional-option-wrapper">
      <h3 class="font-weight-semibold">{{ 'TEXTILE_DATA.FINISHING.FINISHING' | bmsTranslate: {count: 1} }}</h3>

      <div class="flex-row finishing">
        <mat-form-field>
          <mat-label>{{ 'TEXTILE_DATA.FINISHING.FINISHING' | bmsTranslate: {count: 1} }}</mat-label>
          <vdw-object-selection
            formControlName="finishing"
            [objectName]="'TEXTILE_DATA.FINISHING.FINISHING' | bmsTranslate: {count: 1} | lowercase"
            [baseRouterLink]="finishingBaseRouterLink"
            (selectClicked)="selectFinishing()"
          ></vdw-object-selection>
          <mat-error *vdwCanShowErrorForFormControl="'finishing'; error: 'required'">
            {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
          </mat-error>
        </mat-form-field>
        <mat-icon *ngIf="hasChosenFinishing()" class="finishing-info" svgIcon="info" (click)="showFinishingDetails($event)"></mat-icon>
      </div>
    </article>
    <ng-container *ngIf="machine.canHaveRestAndFreeZonesAndPathLabels()">
      <article class="rest-zones flex-column additional-option-wrapper">
        <h3 class="font-weight-semibold">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.REST_ZONE.REST_ZONE' | bmsTranslate: {count: 2} }}</h3>

        <div *ngIf="canShowRestZonePosition()" class="flex-column rest-zone-position-wrapper" formGroupName="restZone">
          <mat-radio-group formControlName="position" class="flex-row">
            <mat-radio-button [value]="possibleRestZonePosition" *ngFor="let possibleRestZonePosition of possibleRestZonePositions">
              {{ getRestZonePositionTranslationKey(possibleRestZonePosition) | bmsTranslate }}
            </mat-radio-button>
          </mat-radio-group>

          <div *ngIf="canShowInputForUserDefinedWidthOfRestZone()" class="flex-row user-defined-rest-zone" formGroupName="userDefinedRest">
            <mat-form-field>
              <mat-select formControlName="position" disableOptionCentering>
                <mat-option *ngFor="let possibleRestZonePosition of possibleRestZoneUserDefinedPositions" [value]="possibleRestZonePosition">
                  {{ getRestZonePositionTranslationKey(possibleRestZonePosition) | bmsTranslate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <input matInput appL10nDecimal type="number" min="0" formControlName="technicalWidthInDents" />
              <span matSuffix>{{ 'GENERAL.UNIT.DENTS' | bmsTranslate }}</span>
              <mat-error *ngIf="canShowErrorForFormControl('required', 'restZone.userDefinedRest.technicalWidthInDents')">
                {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="flex-row additional-option-wrapper-input" appDataCy="rest-zones-pattern">
          <mat-form-field class="full-width" [class.mat-warn]="needsToShowValidationFeedback">
            <mat-label>{{ 'TEXTILE_DATA.MACHINE_QUALITY.PATTERN_OR_DRAWING' | bmsTranslate: {count: 1} }}</mat-label>
            <vdw-object-selection
              appDataCy="rest-zones-pattern-button"
              [formControl]="additionalOptionsForm.get('restZone.pattern')"
              [objectName]="'TEXTILE_DATA.MACHINE_QUALITY.PATTERN_OR_DRAWING' | bmsTranslate: {count: 1} | lowercase"
              [conditionalChipValueKey]="PATTERN_CONDITIONAL_CHIP_VALUE_KEY"
              (selectClicked)="selectPatternForRestZone()"
            ></vdw-object-selection>
            <mat-error *ngIf="canShowErrorForFormControl('required', 'restZone.pattern')">
              {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
            </mat-error>
          </mat-form-field>
          <app-pattern-example
            *ngIf="hasChosenPatternForRestZone()"
            class="pattern-example"
            [weaveQualityType]="weaveQualityType"
            [canShowColor]="true"
            [pattern]="getSelectedPatternForRestZone()"
            [observePatternBeforeVisible]="true"
            [weaveStructureId]="machineQuality.weaveStructure.id"
            (patternReceived)="restZoneLoaded.emit()"
          ></app-pattern-example>
        </div>
      </article>

      <article class="free-zones flex-column additional-option-wrapper" formGroupName="freeZone">
        <h3 class="font-weight-semibold">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.FREE_ZONE.FREE_ZONE' | bmsTranslate: {count: 2} }}</h3>
        <div>
          <div class="flex-row additional-option-wrapper-input">
            <mat-form-field class="full-width">
              <mat-label>{{ 'PRODUCTION_ORDER.CUSTOM_SETTINGS.LEFT' | bmsTranslate }}</mat-label>
              <input matInput appL10nDecimal type="number" min="0" formControlName="leftTechnicalWidthInDents" />
              <span matSuffix>{{ 'GENERAL.UNIT.DENTS' | bmsTranslate }}</span>
              <mat-error *ngIf="canShowErrorForFormControl('required', 'freeZone.leftTechnicalWidthInDents')">
                {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
              </mat-error>
            </mat-form-field>
            <mat-checkbox class="full-width" formControlName="freeZoneLeftUseAsMaximum">
              {{ 'PRODUCTION_ORDER.WEAVE_PLAN.USE_AS_MAXIMUM' | bmsTranslate }}
            </mat-checkbox>
          </div>
          <div class="flex-row additional-option-wrapper-input">
            <mat-form-field class="full-width">
              <mat-label>{{ 'PRODUCTION_ORDER.CUSTOM_SETTINGS.RIGHT' | bmsTranslate }}</mat-label>
              <input matInput appL10nDecimal type="number" min="0" formControlName="rightTechnicalWidthInDents" />
              <span matSuffix>{{ 'GENERAL.UNIT.DENTS' | bmsTranslate }}</span>
              <mat-error *ngIf="canShowErrorForFormControl('required', 'freeZone.rightTechnicalWidthInDents')">
                {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
              </mat-error>
            </mat-form-field>
            <mat-checkbox class="full-width" formControlName="freeZoneRightUseAsMaximum">
              {{ 'PRODUCTION_ORDER.WEAVE_PLAN.USE_AS_MAXIMUM' | bmsTranslate }}
            </mat-checkbox>
          </div>
          <div class="flex-row additional-option-wrapper-input">
            <mat-form-field class="full-width">
              <mat-label>{{ 'PRODUCTION_ORDER.CUSTOM_SETTINGS.IN_BETWEEN' | bmsTranslate }}</mat-label>
              <input matInput appL10nDecimal type="number" min="0" formControlName="inBetweenTechnicalWidthInDents" />
              <span matSuffix>{{ 'GENERAL.UNIT.DENTS' | bmsTranslate }}</span>
              <mat-error *ngIf="canShowErrorForFormControl('required', 'freeZone.inBetweenTechnicalWidthInDents')">
                {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
              </mat-error>
            </mat-form-field>
            <mat-checkbox class="full-width" formControlName="freeZoneInBetweenUseAsMaximum">
              {{ 'PRODUCTION_ORDER.WEAVE_PLAN.USE_AS_MAXIMUM' | bmsTranslate }}
            </mat-checkbox>
          </div>
        </div>
        <div class="flex-row additional-option-wrapper-input">
          <mat-form-field class="full-width" [class.mat-warn]="needsToShowValidationFeedback">
            <mat-label>{{ 'TEXTILE_DATA.MACHINE_QUALITY.PATTERN_OR_DRAWING' | bmsTranslate: {count: 1} }}</mat-label>
            <vdw-object-selection
              [formControl]="additionalOptionsForm.get('freeZone.pattern')"
              [objectName]="'TEXTILE_DATA.MACHINE_QUALITY.PATTERN_OR_DRAWING' | bmsTranslate: {count: 1} | lowercase"
              [conditionalChipValueKey]="PATTERN_CONDITIONAL_CHIP_VALUE_KEY"
              (selectClicked)="selectPatternForFreeZone()"
            ></vdw-object-selection>
            <mat-error *ngIf="canShowErrorForFormControl('required', 'freeZone.pattern')">
              {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
            </mat-error>
          </mat-form-field>
          <app-pattern-example
            *ngIf="hasChosenPatternForFreeZone()"
            class="pattern-example"
            [observePatternBeforeVisible]="true"
            [weaveQualityType]="weaveQualityType"
            [canShowColor]="true"
            [pattern]="getSelectedPatternForFreeZone()"
            [weaveStructureId]="machineQuality.weaveStructure.id"
            (patternReceived)="freeZoneLoaded.emit()"
          ></app-pattern-example>
        </div>
      </article>
    </ng-container>
  </div>
</section>
